import React, { useCallback, useEffect, useState } from "react"

import { Input } from "@coval/ui/input"

import type { AudioSilenceFilterConfig } from "@/types/metrics/metadata"

import { SILENCE_MIN_GAP_DEFAULT_SECONDS } from "../types"

interface SilenceFilterEditorProps {
  filter: AudioSilenceFilterConfig
  onChange: (filter: AudioSilenceFilterConfig) => void
}

export const SilenceFilterEditor: React.FC<SilenceFilterEditorProps> = ({
  filter,
  onChange,
}) => {
  const initial =
    filter.min_gap_seconds !== undefined
      ? filter.min_gap_seconds.toString()
      : ""
  const [localValue, setLocalValue] = useState(initial)

  useEffect(() => {
    setLocalValue(
      filter.min_gap_seconds !== undefined
        ? filter.min_gap_seconds.toString()
        : "",
    )
  }, [filter.min_gap_seconds])

  const commit = useCallback(
    (raw: string) => {
      if (raw.trim() === "") {
        const { min_gap_seconds: _discarded, ...rest } = filter
        onChange(rest)
        return
      }
      const parsed = parseFloat(raw)
      if (!isNaN(parsed) && parsed >= 0) {
        onChange({ ...filter, min_gap_seconds: parsed })
      }
    },
    [filter, onChange],
  )

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const next = e.target.value
    setLocalValue(next)
    commit(next)
  }

  return (
    <div className="flex items-center gap-2">
      <Input
        type="number"
        min={0}
        step={0.1}
        value={localValue}
        onChange={handleChange}
        aria-label="Minimum silence gap seconds"
        placeholder={SILENCE_MIN_GAP_DEFAULT_SECONDS.toString()}
        className="w-24"
      />
      <span className="text-sm text-coval-text-muted">
        seconds min gap (default {SILENCE_MIN_GAP_DEFAULT_SECONDS}s)
      </span>
    </div>
  )
}
